module.exports = __webpack_public_path__ + "img/i-page3-1.3d1b6080.png";